import React, { Component } from 'react';
import Flatpickr from 'react-flatpickr'
var ReactSuperSelect = require('react-super-select')

class Dynamic extends Component {
	constructor(props) {
		super(props);
		this.state = {
			active: false,
			editing: false,
			deleting: false,
			loading: false,
			view: false,
			filterBy: {}, sortBy: '', sortOrder: 1
		};
	}

	edit = (item) => (e) => {
		if (!item) {
			this.setState({ editing: {} })
		} else {
			this.setState({ editing: JSON.parse(JSON.stringify(item)) })
		}
	}

	delete = (item) => (e) => {
		e.stopPropagation()
		this.setState({ deleting: item })
	}

	confirm = (e) => {
		if (this.state.editing) {
			let errorFound = false;

			//dynamic condition definitions
			for (let i of this.props.data[this.state.view].schema) {
				if (i['conditions']) {
					if (i['conditions']['required'] && !this.state.editing[i['name']]) {
						this.setState({ error: 'The ' + i['name'] + ' field is required' });
						errorFound = true;
					} else if (i['conditions']['dateAfter'] && new Date(this.state.editing[i['name']]) < new Date(this.state.editing[i['conditions']['dateAfter']])) {
						this.setState({ error: 'The ' + i['name'] + ' field must be after the ' + i['conditions']['dateAfter'] });
						errorFound = true;
					} else if (i['conditions']['dateBefore'] && new Date(this.state.editing[i['name']]) > new Date(this.state.editing[i['conditions']['dateBefore']])) {
						this.setState({ error: 'The ' + i['name'] + ' field must be before the ' + i['conditions']['dateBefore'] });
						errorFound = true;
					} else if (i['conditions']['equalTo'] && this.state.editing[i['name']] != this.state.editing[i['conditions']['equalTo']]) {
						this.setState({ error: 'The ' + i['name'] + ' field must be equal to ' + i['conditions']['equalTo'] });
						errorFound = true;
					}
				}
			}

			if (!errorFound) {
				this.setState({ loading: true });
				this.props.ws.send(JSON.stringify({ route: 'addEditItem', module: this.state.view, item: this.state.editing }))
			}

		} else if (this.state.deleting) {
			this.setState({ loading: true });
			this.props.ws.send(JSON.stringify({ route: 'deleteItem', module: this.state.view, item: this.state.deleting }))
		}
	}

	cancel = (e) => {
		this.setState({ editing: false, deleting: false, loading: false, error: false })
	}
	toggle = (field) => (e) => {
		var newState = this.state.editing
		newState[field] = newState[field] ? false : true
		this.setState({ editing: newState })
	}
	valueChange = (field, type, parentList, index) => (e) => {
		var newState = this.state.editing
		if (!parentList) {
			if (type == 'string') {
				newState[field] = e.currentTarget.value
			} else if (type == 'longString') {
				newState[field] = e.currentTarget.value
			} else if (type == 'phone') {
				newState[field] = e.currentTarget.value.replace(/\D/gm, '').substr(0, 10)
			}
		} else if (parentList) {
			if (type == 'string') {
				newState[parentList][index][field] = e.currentTarget.value
			} else if (type == 'longString') {
				newState[parentList][index][field] = e.currentTarget.value
			} else if (type == 'phone') {
				newState[parentList][index][field] = e.currentTarget.value.replace(/\D/gm, '').substr(0, 10)
			}
		}


		this.setState({ editing: newState })
	}
	addListItem = (param) => (e) => {
		var newState = JSON.parse(JSON.stringify(this.state.editing))

		var newObject = {}
		for (var field of param.schema) {
			newObject[field.name] = ""
		}
		if (!newState.hasOwnProperty(param.name)) {
			newState[param.name] = []
		}
		newState[param.name].push(newObject)

		this.setState({ editing: newState })
	}

	removeListItem = (param, index) => (e) => {
		var newState = JSON.parse(JSON.stringify(this.state.editing))

		if (!newState.hasOwnProperty(param.name)) {
			newState[param.name] = []
		}
		newState[param.name].splice(index, 1)

		this.setState({ editing: newState })
	}

	timeSelect = (field) => (datetime) => {

		var newState = this.state.editing

		if (datetime && Math.abs(new Date().getTime() - datetime[0].getTime()) < 1000) {
			newState[field] = '12:00'
		} else if (datetime) {
			newState[field] = datetime[0].getHours() + ':' + datetime[0].getMinutes()
		} else {
			delete newState[field]
		}

		this.setState({ editing: newState })
	}
	clearDateTime = (field) => (e) => {
		var newState = this.state.editing
		delete newState[field]
		this.setState({ editing: newState })
	}
	checkEnter = (e) => {
		if (e.keyCode === 13) {
			this.confirm();
		}
	}
	componentWillMount() {
		for (var module in this.props.data) {
			if (this.props.data[module] && this.props.data[module].hasOwnProperty('schema')) {
				this.setState({ view: module, sortBy: this.props.data[module].sortBy })
			}
		}
	}
	componentWillReceiveProps() {
		if (this.state.loading) {
			this.cancel()
		}
	}

	renderDynamicInput = (param, value, parentList, index) => {
		if (param instanceof Array) {
			var grouping = []
			for (subItem of param) {
				grouping.push(this.renderDynamicInput(subItem, parentList ? this.state.editing[parentList][index][subItem.name] : this.state.editing[subItem.name], parentList, index))
			}
			return (<div style={{ display: 'flex' }}>{grouping}</div>)
		} else if (param.type == 'string') {
			return (
				<div style={{ flex: "1 1 50%" }} key={'inputDiv' + param.name} className="snazzyInputBox">
					<input className="textInput" type="text" required value={value} onChange={this.valueChange(param.name, param.type, parentList, index)} ></input>
					<span className="inputBar"></span><label className="textLabel">{param.displayName ? param.displayName : param.name}</label>
				</div>
			)
		} else if (param.type == 'longString') {
			return (
				<div key={'inputDiv' + param.name} className="snazzyInputBox">
					<textarea className="bigTextInput" required value={value} onChange={this.valueChange(param.name, param.type, parentList, index)} ></textarea>
					<label className="textLabel">{param.displayName ? param.displayName : param.name}</label>
				</div>
			)
		} else if (param.type == 'phone') {
			return (
				<div style={{ flex: "1 1 50%" }} key={'inputDiv' + param.name} className="snazzyInputBox">
					<input className="textInput" type="text" required value={value} onChange={this.valueChange(param.name, param.type, parentList, index)} ></input>
					<span className="inputBar"></span><label className="textLabel">{param.displayName ? param.displayName : param.name}</label>
				</div>
			)
		} else if (param.type == 'date') {
			return (
				<div style={{ flex: "1 1 50%", display: 'inline-block' }} key={'inputDiv' + param.name}>
					<div>{param.displayName ? param.displayName : param.name}</div>
					<Flatpickr style={{ border: '1px solid #2A6AA9', padding: '15px', width: '130px', margin: '5px' }} options={{ dateFormat: "Y-m-d" }} value={value} onChange={(date, { name = param.name }) => { this.setState({ editing: { ...this.state.editing, [name]: [date[0]] } }) }} />
				</div>
			)
		} else if (param.type == 'startDate') {
			return (
				<div style={{ flex: "1 1 50%", display: 'inline-block' }} key={'inputDiv' + param.name}>
					<div>{param.displayName ? param.displayName : param.name}</div>
					<Flatpickr style={{ border: '1px solid #2A6AA9', padding: '15px', width: '130px', margin: '5px' }} options={{ dateFormat: "Y-m-d h:i K" }} value={value} onChange={(date, { name = param.name }) => { this.setState({ editing: { ...this.state.editing, [name]: [new Date(new Date(date[0]).setHours(0, 0, 0, 0))] } }) }} />
				</div>
			)
		} else if (param.type == 'endDate') {
			return (
				<div style={{ flex: "1 1 50%", display: 'inline-block' }} key={'inputDiv' + param.name}>
					<div>{param.displayName ? param.displayName : param.name}</div>
					<Flatpickr style={{ border: '1px solid #2A6AA9', padding: '15px', width: '130px', margin: '5px' }} options={{ dateFormat: "Y-m-d h:i K" }} value={value} onChange={(date, { name = param.name }) => { this.setState({ editing: { ...this.state.editing, [name]: [new Date(new Date(date[0]).setHours(23, 59, 59, 0))] } }) }} />
				</div>
			)
		} else if (param.type == 'boolean') {
			return (
				<div style={{ flex: "1 1 50%" }} key={'inputDiv' + param.name} >
					<div>{param.displayName ? param.displayName : param.name}</div>
					<div className="activeBox" onClick={this.toggle(param.name)}>
						<div className={value ? "enabled" : "disabled"}></div>
					</div>
				</div>
			)
		} else if (param.type == 'timeOfDay') {
			return (
				<div style={{ display: 'flex', justifyContent: 'space-between' }}>
					<div style={{ lineHeight: '57px' }}>{param.displayName ? param.displayName : param.name}</div>
					<Flatpickr style={{ border: '1px solid #2A6AA9', padding: '15px', width: '130px', margin: '5px' }} options={{ allowInput: true, dateFormat: "h:i K", noCalendar: true, enableTime: true }} value={value} onChange={this.timeSelect(param.name)} />
					{value ? <div style={{ lineHeight: '57px', cursor: 'pointer' }} onClick={this.clearDateTime(param.name)}>X</div> : ''}
				</div>
			)
		} else if (param.type == 'series') {
			var series = []
			var stopSeries = false
			for (var subItem of param.series) {
				if (subItem instanceof Array) {
					var grouping = []
					var subStopSeries = true
					for (var subSubItem of subItem) {

						if (!this.state.editing.hasOwnProperty(subSubItem.name) || this.state.editing[subSubItem.name] == '' || this.state.editing[subSubItem.name] == null) {
							if (!stopSeries) { grouping.push(this.renderDynamicInput(subSubItem, this.state.editing[subSubItem.name])) }

						} else {
							subStopSeries = false
							grouping.push(this.renderDynamicInput(subSubItem, this.state.editing[subSubItem.name]))
						}

					}
					series.push(<div style={{ display: 'flex' }} key={'groupInput' + subSubItem.name}>{grouping}</div>)
					if (subStopSeries) {
						stopSeries = true
					}
				} else {
					if (!this.state.editing.hasOwnProperty(subItem.name) || this.state.editing[subItem.name] == "" || this.state.editing[subItem.name] == null) {
						if (!stopSeries) { series.push(this.renderDynamicInput(subItem, this.state.editing[subItem.name])) }
						stopSeries = true
					} else {
						series.push(this.renderDynamicInput(subItem, this.state.editing[subItem.name]))
					}
				}
			}
			return (<div key={'seriesInput' + param.name}>{series}</div>)

		} else if (param.type == 'dynamicDropdown') {
			return (
				<div style={{ flex: "1 1 50%" }} key={'inputDiv' + param.name} >
					<div>{param.displayName ? param.displayName : param.name}</div>
					<ReactSuperSelect ajaxDataFetch={() => { return new Promise(async (res, rej) => { var response = await fetch(window.location.origin + '/data?path=' + param.path); if (response.ok) { var ddArray = []; var ddItems = await response.json(); for (var ddItem in ddItems) { ddArray.push({ id: ddItems[ddItem][param.param], name: ddItems[ddItem][param.param] }) }; res(ddArray) }; }) }} initialValue={{ id: this.state.editing[param.name], name: this.state.editing[param.name] }} onChange={this.selectDDDValue(param.name)} />

				</div>
			)
		} else if (param.type == 'dropdown') {
			return (
				<div style={{ flex: "1 1 50%" }} key={'inputDiv' + param.name} >
					<div>{param.displayName ? param.displayName : param.name}</div>
					<ReactSuperSelect dataSource={param.options} initialValue={{ id: parentList ? this.state.editing[parentList][index][param.name] : this.state.editing[param.name], name: parentList ? this.state.editing[parentList][index][param.name] : this.state.editing[param.name] }} onChange={this.selectDDDValue(param.name, parentList, index)} />

				</div>
			)
		} else if (param.type == 'list') {
			var list = []
			if (this.state.editing[param.name] && this.state.editing[param.name].length > 0) {
				for (var [i, subItem] of this.state.editing[param.name].entries()) {
					console.log(subItem)
					var listItem = []
					for (var field of param.schema) {
						listItem.push(this.renderDynamicInput(field, this.state.editing[param.name][i][field.name], param.name, i))
					}
					list.push(
						<div style={{ position: 'relative' }}>
							<div onClick={this.removeListItem(param, i)} style={{ cursor: 'pointer', position: 'absolute', right: '-25px', top: '40%' }}>X</div>
							{listItem}
							<hr />
						</div>
					)
				}
			}
			return (
				<div key={'listInput' + param.name}>
					<div>{param.displayName ? param.displayName : param.name}</div>
					<hr />
					{list}
					<div style={{ width: '150px', margin: '10px auto', cursor: 'pointer', border: '1px solid #2A6AA9', padding: '5px 10px' }} onClick={this.addListItem(param)}>{list.length > 0 ? '+ Add Another' : '+ Add An Item'}</div>
				</div>)
		} else if (param.type == 'static') {
			return (
				<div style={{ flex: "1 1 50%" }} key={'inputDiv' + param.name} className="snazzyInputBox">
					<input className="textInput" type="text" required value={value} disabled={true}></input>
					<br />
				</div>
			)
		}
	}

	selectDDDValue = (field, parentList, index) => (valueObject) => {
		var newState = JSON.parse(JSON.stringify(this.state.editing))
		if (parentList) {
			if (valueObject && valueObject.name) {
				newState[parentList][index][field] = valueObject.name
			} else {
				delete newState[parentList][index][field]
			}
		} else {
			if (valueObject && valueObject.name) {
				newState[field] = valueObject.name
			} else {
				delete newState[field]
			}
		}

		this.setState({ editing: newState })
	}

	getDisplayIdentifier = (item) => {
		var oneLevelDeeper = (subItem) => {
			if (subItem instanceof Array) {
				return oneLevelDeeper(subItem[0])
			} else {
				return subItem.displayName ? subItem.displayName : subItem.name
			}
		}
		return oneLevelDeeper(this.props.data[this.state.view].schema[0])
	}

	getIdentifier = (item) => {
		var oneLevelDeeper = (subItem) => {
			if (subItem instanceof Array) {
				return oneLevelDeeper(subItem[0])
			} else {
				return subItem.name
			}
		}
		return oneLevelDeeper(this.props.data[this.state.view].schema[0])
	}

	sort = (sortBy) => (e) => {
		var sortOrder
		if (this.state.sortOrder === -1) {
			sortOrder = 1;
		} else {
			sortOrder = -1;
		}
		this.setState({ sortBy: sortBy, sortOrder: sortOrder })
	}

	filter = (field) => (e) => {
		var filterBy = this.state.filterBy
		if (e.target.value.length > 0) {
			filterBy[field] = e.target.value
		} else {
			delete filterBy[field]
		}
		this.setState({ filterBy: filterBy })
	}

	sortFunc = (sortBy, sortOrder) => {
		return function (a, b) {
			if (sortBy === "status" || sortBy === "ActivityDateTime") {
				if ('status' in a && 'status' in b) {
					if (!a.loggedIn && !b.loggedIn) {
						return a.username > b.username ? 1 * sortOrder : -1 * sortOrder
					} else if (!a.loggedIn) {
						return 1
					} else if (!b.loggedIn) {
						return -1
					}
					if (a[sortBy] === b[sortBy]) {
						return a.username > b.username ? 1 * sortOrder : -1 * sortOrder
					}
					return a[sortBy] > b[sortBy] ? 1 * sortOrder : -1 * sortOrder
				} else {
					if ('status' in a) {
						return -1
					}
					return 1
				}
			}

			if (sortBy in a && sortBy in b) {
				if (a[sortBy] === b[sortBy]) {
					return a.email > b.email ? 1 * sortOrder : -1 * sortOrder
				}
				return a[sortBy] > b[sortBy] ? 1 * sortOrder : -1 * sortOrder
			} else if (!(sortBy in a) && !(sortBy in b)) {
				return a.email > b.email ? 1 * sortOrder : -1 * sortOrder
			} else {
				return sortBy in a ? -1 : 1
			}
		}
	}

	filterFunc = (array, filterBy) => {
		return array.filter(function (object) {
			for (var prop in filterBy) {
				if (typeof object[prop] === "undefined") {
					return false
				}
				//console.log(object[prop])
				if (object[prop] == null || object[prop] == undefined || object[prop].toString().toLowerCase().indexOf(filterBy[prop].toString().toLowerCase()) < 0) {
					return false
				}
			}
			return true;
		})
	}

	render() {
		console.log('this.props.data');
		console.log(this.props.data);
		//Get the header, it is the second key in this.props.data object
		//console.log(Object.keys(this.props.data)[1]);
		var header = Object.keys(this.props.data).filter((key) => key !== 'Dyanmic')[0]
		if (this.props.active) {
			var items = []

			for (var id in this.props.data[this.state.view].data) {
				items.push(this.props.data[this.state.view].data[id]);
			}
			//Filtering items List
			if (Object.keys(this.state.filterBy).length > 0) {
				items = this.filterFunc(items, this.state.filterBy)
			}

			//Sorting filtered User List
			if (this.state.sortBy !== '') {
				items.sort(this.sortFunc(this.state.sortBy, this.state.sortOrder))
			}
			var list = []
			var i = 0
			for (var item of items) {
				var fields = []
				for (var displayParam of this.props.data[this.state.view].schema) {
					if (displayParam instanceof Array) {
						for (var subItem of displayParam) {
							if (subItem.display) {
								fields.push(
									<span key={i++} style={{ flex: '1 1 100px' }} >{item[subItem.name]}</span>
								)
							}
						}
					} else {
						if (displayParam.display) {
							switch (displayParam.type) {
								case 'boolean':
									fields.push(
										<span key={i++} style={{ flex: '1 1 100px' }}>{item[displayParam.name] == true ? "true" : "false"}</span>
									)
									break;
								case 'date':
									fields.push(
										<span key={i++} style={{ flex: '1 1 100px' }}>{item[displayParam.name] ? new Date(item[displayParam.name]).toDateString() : ''}</span>
									)
									break;
								case 'startDate':
									fields.push(
										<span key={i++} style={{ flex: '1 1 100px' }}>{item[displayParam.name] ? new Date(item[displayParam.name]).toDateString() + ' ' + new Date(item[displayParam.name]).toLocaleTimeString() : ''}</span>
									)
									break;
								case 'endDate':
									fields.push(
										<span key={i++} style={{ flex: '1 1 100px' }}>{item[displayParam.name] ? new Date(item[displayParam.name]).toDateString() + ' ' + new Date(item[displayParam.name]).toLocaleTimeString() : ''}</span>
									)
									break;
								default:
									fields.push(
										<span key={i++} style={{ flex: '1 1 100px' }}>{item[displayParam.name]}</span>
									)
									break;
							}
						}
					}
				}
				list.push(
					<div className="dataRow" key={item.id} onClick={this.props.data[this.state.view].actions.edit ? this.edit(item) : ''} >
						{fields}
						{this.props.data[this.state.view].actions.delete ?
							<span className="buttonBox" style={{ flex: '1 1 100px' }}>
								<img src={this.props.img.delete} alt="Delete Holiday" onClick={this.delete(item)} />
							</span>
							: ''
						}
					</div>
				)
			}
			var headers = []
			var filters = []
			for (var param of this.props.data[this.state.view].schema) {
				if (param instanceof Array) {
					for (var subItem of param) {
						if (subItem.display) {
							headers.push(
								<span key={'header' + subItem.name} style={{ cursor: 'pointer', flex: '1 1 100px' }} onClick={this.sort(subItem.name)} >{subItem.displayName ? subItem.displayName : subItem.name}</span>
							)
							filters.push(
								<input key={'filter' + subItem.name} style={{ flex: '1 1 100px' }} type="text" onChange={this.filter(subItem.name)} value={this.state.filterBy[subItem.name]} />
							)
						}
					}
				} else {
					if (param.display) {
						headers.push(
							<span key={'header' + param.name} onClick={this.sort(param.name)} style={{ cursor: 'pointer', flex: '1 1 100px' }} >{param.displayName ? param.displayName : param.name}</span>
						)
						filters.push(
							<input key={'filter' + param.name} style={{ flex: '1 1 100px' }} type="text" onChange={this.filter(param.name)} value={this.state.filterBy[param.name]} />
						)
					}
				}

			}
			if (this.props.data[this.state.view].actions.delete) {
				headers.push(
					<span key={'headerButtonBox'} style={{ flex: '1 1 100px' }} ></span>
				)
				filters.push(
					<span key={'headerButtonBox'} style={{ flex: '1 1 100px' }} ></span>
				)
			}

			var editing, deleting
			if (this.state.editing) {
				var editfields = []
				for (var param of this.props.data[this.state.view].schema) {
					editfields.push(this.renderDynamicInput(param, this.state.editing[param.name]))
				}
				editing = (
					<div className="blackout" tabIndex="1" autoFocus onKeyUp={this.checkEnter}>
						<div className="pop" >
							<div className="viewCloser" onClick={this.cancel}></div>

							{editfields}

							<div className="error" style={{ padding: '15px' }}>{this.state.error}</div>

							{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirm}>Confirm</div>}
						</div>
					</div>
				)
			}

			if (this.state.deleting) {
				deleting = (
					<div className="blackout" tabIndex="1" autoFocus onKeyUp={this.checkEnter}>
						<div className="pop" >
							<div className="viewCloser" onClick={this.cancel}></div>

							<div>You are removing</div>
							<div style={{ padding: '25px' }}>{this.getDisplayIdentifier(this.props.data[this.state.view].schema[0])}: {this.state.deleting[this.getIdentifier(this.props.data[this.state.view].schema[0])]} </div>
							{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirm}>Confirm</div>}
						</div>
					</div>
				)
			}
			return (
				<div width="100%">
					<h1 style={{ textAlign: 'center', color: '#137', marginBottom: '10px' }}>
						{header}
					</h1>
					{this.props.data[this.state.view].actions.add ? (
						<img
							src={this.props.img.plus}
							className="plusButton"
							alt="Add"
							onClick={this.edit(null)}
						/>
					) : (
						''
					)}
					<div className="dataHeaders">{headers}</div>
					<div className="dataFilters">{filters}</div>
					<div style={{ color: '#137', padding: '5px 10px', fontWeight: '400', fontSize: '20px' }}>
						{'Displaying ' + list.length + ' of ' + Object.keys(this.props.data[this.state.view].data).length + ' Records...'}
					</div>
					<div style={{ overflow: 'auto', height: 'calc(100% - 85px)' }}>
						{list}
					</div>
					{editing}
					{deleting}
				</div>
			);
		} else {
			return (
				<div width="100%">

				</div>
			);
		}
	}
}

const icon = "menuObject"
export { Dynamic, icon }